export const ACCESS_CONTROL_ALLOW_ORIGIN = 'Access-Control-Allow-Origin';
export const ACCESS_CONTROL_ALLOW_CREDENTIALS =
  'Access-Control-Allow-Credentials';
export const ACCESS_CONTROL_ALLOW_METHODS = 'Access-Control-Allow-Methods';
export const ACCESS_CONTROL_ALLOW_HEADERS = 'Access-Control-Allow-Headers';
export const ACCESS_CONTROL_EXPOSE_HEADERS = 'Access-Control-Expose-Headers';
export const ACCESS_CONTROL_MAX_AGE = 'Access-Control-Max-Age';
